import React from 'react';

import { Box, Radio, Tab, Typography } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import PropTypes from 'prop-types';

import { LabelSize } from '../LabelCDS/LabelCDS.constants';

import { badgeStyles, labelContainerStyles, radioStyles } from './TabCDS.styles';

const TabCDS = ({
  title,
  value,
  count,
  checked,
  tabIcon: TabIcon,
  labelProps,
  disabled = false,
  ...restProps
}) => {
  return (
    <Tab
      disabled={disabled}
      label={
        <Typography component="div" sx={labelContainerStyles} variant="medium16">
          {checked !== undefined && <Radio checked={checked} size="small" sx={radioStyles} />}
          {title}
          {count !== undefined && <Box sx={badgeStyles}>{count}</Box>}
          {TabIcon && <TabIcon size={20} />}
          {labelProps && <LabelCDS size={LabelSize.L} {...labelProps} />}
        </Typography>
      }
      value={value}
      {...restProps}
    />
  );
};

TabCDS.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  count: PropTypes.number,
  checked: PropTypes.bool,
  tabIcon: PropTypes.elementType,
  labelProps: PropTypes.shape({
    title: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string,
  }),
  disabled: PropTypes.bool,
};

export default TabCDS;
